module.exports = __webpack_public_path__ + "media/components/images/panels/2-a-930eb46213a9ab126eec4012056ef138.jpeg";